export default {
	baseUrl: '/auth',
	profile: {
		baseUrl: '/auth/profile'
	},
	signin: '#signin',
	signup: '#signup'
}
